module.exports = __webpack_public_path__ + "static/media/Peapod Costume Girl.ddf7ba92.jpg";